import ListCRUD from "mrf/view/ListCRUD";
import React from "react";
import dateTimeFormatter from "mrf/utils/DateTimeFormatter";

export default function LoggedRequests() {
    const fields = [
        { name: 'Timestamp', key: 'requestTimestamp', map: t => dateTimeFormatter(t, 'L LTS')},
        { name: 'Username', keys: ['requestUser', 'userName'], },
        { name: 'Request Method', key: 'requestMethod', },
        { name: 'URL', key: 'url', },
    ];
    
    return <ListCRUD
        singular='loggedRequest'
        fields={fields}
        disableNewButton
        disableViewButton
        disableEditButton
    />;
}